import { Box, styled } from "@mui/material"
import React from "react"

const IframeWrapper = styled(Box)(() => ({
  position: 'relative',
  marginBottom: '1rem',
}))

const Iframe = styled('iframe')({
  border: 0,
  width: '100%',
  height: '100%',
})

const Overlay = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  cursor: 'pointer',
  backgroundColor: 'transparent',
}))


interface IIFrameProps {
    style?: React.CSSProperties | undefined
    id?: string
    src: string | undefined
    handleOpen?: () => void
    disableOverlay?: boolean
}

const IFrame: React.FC<IIFrameProps> = React.memo(({style, id, handleOpen, src, disableOverlay}) => {
    return (
        <IframeWrapper
            style={style}
            key={id}
            onClick={handleOpen}
        >
            <Iframe src={src} title={`Panel ${id}`} />
            {disableOverlay? null: <Overlay/>}
        </IframeWrapper>
    )
})

export default IFrame